import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import PageIssueCard from "@/components/pages/PageIssueCard";
import type { PageIssue, PageIssuePriority } from "@/types";

type Props = {
  priority: PageIssuePriority;
  issues: PageIssue[];
};

export default function PageIssueGroup({ priority, issues }: Props) {
  if (issues.length === 0) return null;

  return (
    <section className="space-y-4">
      <h2 className={`flex items-center gap-2 text-lg font-semibold ${priorityTextClasses(priority)}`}>
        <ExclamationTriangleIcon className="h-5 w-5" aria-hidden="true" />
        {priorityLabel(priority)}
        <span className="font-normal text-gray-400">({issues.length})</span>
      </h2>

      <div className={`space-y-4 border-l-4 pl-4 ${priorityBorderClasses(priority)}`}>
        {issues.map((issue) => (
          <PageIssueCard key={issue.id} issue={issue} />
        ))}
      </div>
    </section>
  );
}

function priorityLabel(priority: PageIssuePriority) {
  if (priority === "high") return "High priority issues";
  if (priority === "medium") return "Medium priority issues";

  return "Low priority issues";
}

function priorityTextClasses(priority: PageIssuePriority) {
  if (priority === "high") return "text-red-700";
  if (priority === "medium") return "text-orange-700";

  return "text-yellow-700";
}

function priorityBorderClasses(priority: PageIssuePriority) {
  if (priority === "high") return "border-red-200";
  if (priority === "medium") return "border-orange-200";

  return "border-yellow-200";
}
